import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { QuotesService } from '../../../core/data/services/quotes.service';

export const quoteIssuedGuard: CanActivateFn = (route, state) => {
    const quotesService = inject(QuotesService);
    const router = inject(Router);

    const status = quotesService.currentQuote?.status?.toString()?.toLowerCase() || '';

    // Check for 'issued' or '2' (enum value)
    if (status === 'issued' || status === '2') {
        return true;
    }

    // Redirect if not issued
    return router.createUrlTree(['/']);
};
